//  import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TextEdit = (props) => {
  const [editorState, setEditorState] = useState(props.initialValue);

  useEffect(() => {
    console.log("props.initialValue", props.initialValue);
    if (props.initialValue) {
      // var test =  removeTags( props.initialValue)
      // console.log("test_desc", test);
      setEditorState(props.initialValue);
    }
  }, [props.initialValue]);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    props.onChange(editorState);
    console.log(editorState, "editorState");
  };

  return (
    <>
      <div className="editor">
 
        <ReactQuill
          theme="snow"
          value={editorState}
          onChange={onEditorStateChange}
        />
      </div>
    </>
  );
};
export default TextEdit;
